import log from "loglevel";

if (process.env.NODE_ENV !== "production") {
  log.enableAll();
}

export default log;
